import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles({
  root: { height: (props) => props.height },
})

function Index({ height = 200, text = "No results found" }) {
  const classes = useStyles({ height })
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.root}
    >
      <Typography variant="body2" color="textSecondary">
        {text}
      </Typography>
    </Grid>
  )
}

export default Index
